msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/i18n/remote.tsx
msgid "{added} added lines, {deleted} deleted lines"
msgstr "新增 {added} 行，删除 {deleted} 行"

#: src/i18n/remote.tsx
msgid "{answered} of {total} answered"
msgstr "已回答 {answered}/{total} 个问题"

#: src/i18n/remote.tsx
msgid "{count, plural, one {# question} other {# questions}}"
msgstr "{count, plural, other {# 个问题}}"

#: src/i18n/remote.tsx
msgid "{count} bytes"
msgstr "{count} 字节"

#: src/i18n/remote.tsx
msgid "{count} more files"
msgstr "还有 {count} 个文件"

#: src/i18n/remote.tsx
msgid "{count} more output blocks"
msgstr "还有 {count} 个输出块"

#: src/i18n/remote.tsx
msgid "{duration} ms"
msgstr "{duration} 毫秒"

#: src/i18n/remote.tsx
msgid "{header} requires an answer."
msgstr "请回答“{header}”。"

#: src/i18n/remote.tsx
msgid "{hours}h {remainingMinutes}m {remainder}s"
msgstr "{hours} 时 {remainingMinutes} 分 {remainder} 秒"

#: src/i18n/remote.tsx
msgid "{index}. {header}"
msgstr "{index}. {header}"

#: src/i18n/remote.tsx
msgid "{index}. {header}, answered"
msgstr "{index}. {header}，已回答"

#: src/i18n/remote.tsx
msgid "{label} has an invalid length."
msgstr "{label} 的长度不符合要求。"

#: src/i18n/remote.tsx
msgid "{label} has an invalid number of selections."
msgstr "{label} 的选项数量不符合要求。"

#: src/i18n/remote.tsx
msgid "{label} is outside the allowed range."
msgstr "{label} 超出允许范围。"

#: src/i18n/remote.tsx
msgid "{label} requires a value."
msgstr "{label} 必须填写。"

#: src/i18n/remote.tsx
msgid "{minutes}m {remainder}s"
msgstr "{minutes} 分 {remainder} 秒"

#: src/i18n/remote.tsx
msgid "{seconds}s"
msgstr "{seconds} 秒"

#: src/i18n/remote.tsx
msgid "{value} (last known)"
msgstr "{value}（最后已知值）"

#: src/i18n/remote.tsx
msgid "Add feedback to request a revised plan."
msgstr "填写反馈以要求修改计划。"

#: src/i18n/remote.tsx
msgid "Added"
msgstr "新增"

#: src/i18n/remote.tsx
msgid "Agent activity"
msgstr "Agent 活动"

#: src/i18n/remote.tsx
msgid "Agent command failed."
msgstr "Agent 命令失败。"

#: src/i18n/remote.tsx
msgid "Agent error"
msgstr "Agent 错误"

#: src/i18n/remote.tsx
msgid "Agent failed"
msgstr "Agent 失败"

#: src/i18n/remote.tsx
msgid "Agent questions"
msgstr "Agent 提问"

#: src/i18n/remote.tsx
msgid "Agent timeline"
msgstr "Agent 时间线"

#: src/i18n/remote.tsx
msgid "Allow for session"
msgstr "本次会话允许"

#: src/i18n/remote.tsx
msgid "Allow for turn"
msgstr "允许本轮"

#: src/i18n/remote.tsx
msgid "Allow once"
msgstr "允许一次"

#: src/i18n/remote.tsx
msgid "Allow was offered with no approval scope."
msgstr "允许操作缺少批准范围。"

#: src/i18n/remote.tsx
msgid "Allowed · once"
msgstr "已允许 · 一次"

#: src/i18n/remote.tsx
msgid "Allowed · session"
msgstr "已允许 · 本次会话"

#: src/i18n/remote.tsx
msgid "Allowed · turn"
msgstr "已允许 · 本轮"

#: src/i18n/remote.tsx
msgid "Also changes the default for future sessions."
msgstr "同时更改以后新会话的默认设置。"

#: src/i18n/remote.tsx
msgid "Answered"
msgstr "已回答"

#: src/i18n/remote.tsx
msgid "Approve"
msgstr "批准"

#: src/i18n/remote.tsx
msgid "Approve and execute"
msgstr "批准并执行"

#: src/i18n/remote.tsx
msgid "Approved"
msgstr "已批准"

#: src/i18n/remote.tsx
msgid "Approved and resumed"
msgstr "已批准并继续执行"

#: src/i18n/remote.tsx
msgid "Assistant"
msgstr "助手"

#: src/i18n/remote.tsx
msgid "Assistant message"
msgstr "助手消息"

#: src/i18n/remote.tsx
msgid "Available"
msgstr "可用"

#: src/i18n/remote.tsx
msgid "Back to reference {reference}"
msgstr "返回引用 {reference}"

#: src/i18n/remote.tsx
msgid "Back to reference {reference}-{rereferenceIndex}"
msgstr "返回引用 {reference}-{rereferenceIndex}"

#: src/i18n/remote.tsx
msgid "Back to session controls"
msgstr "返回会话控制"

#: src/i18n/remote.tsx
msgid "Cancel"
msgstr "取消"

#: src/i18n/remote.tsx
msgid "Canceled"
msgstr "已取消"

#: src/i18n/remote.tsx
msgid "Cancellation requested."
msgstr "已请求取消。"

#: src/i18n/remote.tsx
msgid "Changes apply to subsequent turns."
msgstr "更改将应用于后续轮次。"

#: src/i18n/remote.tsx
msgid "Choose…"
msgstr "请选择…"

#: src/i18n/remote.tsx
msgid "Close"
msgstr "关闭"

#: src/i18n/remote.tsx
msgid "Close session controls"
msgstr "关闭会话控件"

#: src/i18n/remote.tsx
msgid "Close skill details"
msgstr "关闭技能详情"

#: src/i18n/remote.tsx
msgid "Closed"
msgstr "已关闭"

#: src/i18n/remote.tsx
msgid "Command"
msgstr "命令"

#: src/i18n/remote.tsx
msgid "Command details"
msgstr "命令详情"

#: src/i18n/remote.tsx
msgid "Completed"
msgstr "已完成"

#: src/i18n/remote.tsx
msgid "connect"
msgstr "连接"

#: src/i18n/remote.tsx
msgid "Connected"
msgstr "已连接"

#: src/i18n/remote.tsx
msgid "Connecting"
msgstr "连接中"

#: src/i18n/remote.tsx
msgid "Connection"
msgstr "连接"

#: src/i18n/remote.tsx
msgid "Connection unavailable"
msgstr "连接不可用"

#: src/i18n/remote.tsx
msgid "Console"
msgstr "控制台"

#: src/i18n/remote.tsx
msgid "Context compaction"
msgstr "上下文压缩"

#: src/i18n/remote.tsx
msgid "CONTINUE IN BROWSER"
msgstr "在浏览器中继续"

#: src/i18n/remote.tsx
msgid "Custom response"
msgstr "自定义回答"

#: src/i18n/remote.tsx
msgid "Decline"
msgstr "拒绝"

#: src/i18n/remote.tsx
msgid "Declined"
msgstr "已拒绝"

#: src/i18n/remote.tsx
msgid "Deleted"
msgstr "已删除"

#: src/i18n/remote.tsx
msgid "Denied"
msgstr "已拒绝"

#: src/i18n/remote.tsx
msgid "deny"
msgstr "拒绝"

#: src/i18n/remote.tsx
msgid "Deny"
msgstr "拒绝"

#: src/i18n/remote.tsx
msgid "Detail renderer unavailable"
msgstr "详情渲染器不可用"

#: src/i18n/remote.tsx
msgid "Diff for {path}"
msgstr "{path} 的差异"

#: src/i18n/remote.tsx
msgid "Diff preview for {path}"
msgstr "{path} 的差异预览"

#: src/i18n/remote.tsx
msgid "Directory"
msgstr "目录"

#: src/i18n/remote.tsx
msgid "Disconnected. Values are last known; reconnect to change settings."
msgstr "已断开连接。显示的是最后已知值；重新连接后可更改设置。"

#: src/i18n/remote.tsx
msgctxt "Interaction response"
msgid "Dismiss"
msgstr "跳过"

#: src/i18n/remote.tsx
msgid "Dismissed"
msgstr "已跳过"

#: src/i18n/remote.tsx
msgid "Documentation is not available to preview."
msgstr "无法预览文档。"

#: src/i18n/remote.tsx
msgid "Download resource"
msgstr "下载资源"

#: src/i18n/remote.tsx
msgid "Earlier activity could not be loaded."
msgstr "无法加载更早的活动。"

#: src/i18n/remote.tsx
msgid "Edit"
msgstr "编辑"

#: src/i18n/remote.tsx
msgid "Enter to send · Shift+Enter for a new line · / for commands"
msgstr "Enter 发送 · Shift+Enter 换行 · / 打开命令"

#: src/i18n/remote.tsx
msgid "Enter to send now · Shift+Enter for a new line · / for commands"
msgstr "Enter 立即发送 · Shift+Enter 换行 · / 打开命令"

#: src/i18n/remote.tsx
msgid "Executing command"
msgstr "正在执行命令"

#: src/i18n/remote.tsx
msgid "Execution plan"
msgstr "执行计划"

#: src/i18n/remote.tsx
msgid "Exit code {code}"
msgstr "退出码 {code}"

#: src/i18n/remote.tsx
msgid "EXTERNAL ACTION"
msgstr "外部操作"

#: src/i18n/remote.tsx
msgid "Failed"
msgstr "失败"

#: src/i18n/remote.tsx
msgid "File change"
msgstr "文件变更"

#: src/i18n/remote.tsx
msgid "File changes"
msgstr "文件变更"

#: src/i18n/remote.tsx
msgid "File changes preview"
msgstr "文件变更预览"

#: src/i18n/remote.tsx
msgid "filesystem"
msgstr "文件系统"

#: src/i18n/remote.tsx
msgid "Footnotes"
msgstr "脚注"

#: src/i18n/remote.tsx
msgid "FORM"
msgstr "表单"

#: src/i18n/remote.tsx
msgid "from"
msgstr "原路径"

#: src/i18n/remote.tsx
msgid "Hidden answer"
msgstr "已隐藏的回答"

#: src/i18n/remote.tsx
msgid "Hide questions"
msgstr "隐藏问题"

#: src/i18n/remote.tsx
msgid "I have completed this"
msgstr "我已完成此操作"

#: src/i18n/remote.tsx
msgid "In progress"
msgstr "进行中"

#: src/i18n/remote.tsx
msgid "INFORMATION REQUEST"
msgstr "信息请求"

#: src/i18n/remote.tsx
msgid "Input accepted for the current turn."
msgstr "当前轮次已接受输入。"

#: src/i18n/remote.tsx
msgid "INPUT REQUIRED"
msgstr "需要输入"

#: src/i18n/remote.tsx
msgid "Interaction response failed."
msgstr "交互回答提交失败。"

#: src/i18n/remote.tsx
msgid "Interaction unavailable"
msgstr "无法进行交互"

#: src/i18n/remote.tsx
msgid "Interrupt"
msgstr "中断"

#: src/i18n/remote.tsx
msgid "Interrupt failed."
msgstr "中断失败。"

#: src/i18n/remote.tsx
msgid "Interrupt is unavailable for this Provider."
msgstr "此 Provider 不支持中断。"

#: src/i18n/remote.tsx
msgid "Interrupt requested"
msgstr "已请求中断"

#: src/i18n/remote.tsx
msgid "Interrupt the current native operation"
msgstr "中断当前原生操作"

#: src/i18n/remote.tsx
msgid "Interrupting…"
msgstr "正在中断…"

#: src/i18n/remote.tsx
msgid "Invalid interaction request"
msgstr "交互请求无效"

#: src/i18n/remote.tsx
msgid "Let the native Provider handle this after the current turn"
msgstr "让原生 Provider 在当前轮次结束后处理"

#: src/i18n/remote.tsx
msgid "Live provider controls"
msgstr "实时 Provider 控件"

#: src/i18n/remote.tsx
msgid "Load earlier activity"
msgstr "加载更早的活动"

#: src/i18n/remote.tsx
msgid "Load resource"
msgstr "加载资源"

#: src/i18n/remote.tsx
msgid "Loading documentation…"
msgstr "正在加载文档…"

#: src/i18n/remote.tsx
msgid "Loading earlier activity…"
msgstr "正在加载更早的活动…"

#: src/i18n/remote.tsx
msgid "Loading native commands…"
msgstr "正在加载原生命令…"

#: src/i18n/remote.tsx
msgid "Loading resource…"
msgstr "正在加载资源…"

#: src/i18n/remote.tsx
msgid "Markdown table"
msgstr "Markdown 表格"

#: src/i18n/remote.tsx
msgid "Message"
msgstr "消息"

#: src/i18n/remote.tsx
msgid "Message queued by Provider."
msgstr "消息已由 Provider 加入队列。"

#: src/i18n/remote.tsx
msgid "Message sent."
msgstr "消息已发送。"

#: src/i18n/remote.tsx
msgid "Message the Agent…"
msgstr "给 Agent 发消息…"

#: src/i18n/remote.tsx
msgid "Model"
msgstr "模型"

#: src/i18n/remote.tsx
msgid "Model settings"
msgstr "模型设置"

#: src/i18n/remote.tsx
msgid "Model: {value}"
msgstr "模型：{value}"

#: src/i18n/remote.tsx
msgid "Modified"
msgstr "修改"

#: src/i18n/remote.tsx
msgid "Native command failed."
msgstr "原生命令失败。"

#: src/i18n/remote.tsx
msgid "Native commands"
msgstr "原生命令"

#: src/i18n/remote.tsx
msgid "network"
msgstr "网络"

#: src/i18n/remote.tsx
msgid "Next"
msgstr "下一步"

#: src/i18n/remote.tsx
msgid "No"
msgstr "否"

#: src/i18n/remote.tsx
msgid "No answer provided"
msgstr "未提供回答"

#: src/i18n/remote.tsx
msgid "No answers"
msgstr "尚未回答"

#: src/i18n/remote.tsx
msgid "No diff content provided."
msgstr "未提供差异内容。"

#: src/i18n/remote.tsx
msgid "No file changes reported."
msgstr "未报告文件变更。"

#: src/i18n/remote.tsx
msgid "No matching native commands."
msgstr "没有匹配的原生命令。"

#: src/i18n/remote.tsx
msgid "No output."
msgstr "无输出。"

#: src/i18n/remote.tsx
msgid "No results."
msgstr "无结果。"

#: src/i18n/remote.tsx
msgid "No timeline activity."
msgstr "暂无时间线活动。"

#: src/i18n/remote.tsx
msgid "Normal chat"
msgstr "普通聊天"

#: src/i18n/remote.tsx
msgid "Not provided"
msgstr "未提供"

#: src/i18n/remote.tsx
msgid "Off"
msgstr "关闭"

#: src/i18n/remote.tsx
msgid "On"
msgstr "开启"

#: src/i18n/remote.tsx
msgid "Open {host}"
msgstr "打开 {host}"

#: src/i18n/remote.tsx
msgid "Open chat commands"
msgstr "打开聊天命令"

#: src/i18n/remote.tsx
msgid "Open or attach to an Agent first."
msgstr "请先打开或连接 Agent。"

#: src/i18n/remote.tsx
msgid "Open resource"
msgstr "打开资源"

#: src/i18n/remote.tsx
msgid "Opening…"
msgstr "正在打开…"

#: src/i18n/remote.tsx
msgid "Output"
msgstr "输出"

#: src/i18n/remote.tsx
msgid "Partially answered"
msgstr "部分已回答"

#: src/i18n/remote.tsx
msgid "Pending"
msgstr "待处理"

#: src/i18n/remote.tsx
msgid "Pending interactions"
msgstr "待处理的交互"

#: src/i18n/remote.tsx
msgid "PERMISSION REQUEST"
msgstr "权限请求"

#: src/i18n/remote.tsx
msgid "Permission settings"
msgstr "权限设置"

#: src/i18n/remote.tsx
msgid "Permissions"
msgstr "权限"

#: src/i18n/remote.tsx
msgid "PERMISSIONS"
msgstr "权限"

#: src/i18n/remote.tsx
msgid "Permissions: {value}"
msgstr "权限：{value}"

#: src/i18n/remote.tsx
msgid "PLAN REVIEW"
msgstr "计划审核"

#: src/i18n/remote.tsx
msgid "Planning"
msgstr "规划中"

#: src/i18n/remote.tsx
msgid "Planning can change only while connected and idle, with no pending interactions."
msgstr "仅在已连接、空闲且无待处理交互时可更改规划模式。"

#: src/i18n/remote.tsx
msgid "Planning is not supported by this session."
msgstr "此会话不支持规划。"

#: src/i18n/remote.tsx
msgid "Planning mode"
msgstr "规划模式"

#: src/i18n/remote.tsx
msgid "Planning mode could not be changed."
msgstr "无法更改规划模式。"

#: src/i18n/remote.tsx
msgid "Planning mode is read-only for this session."
msgstr "此会话的规划模式为只读。"

#: src/i18n/remote.tsx
msgid "Previous"
msgstr "上一个"

#: src/i18n/remote.tsx
msgid "Prompt"
msgstr "提示词"

#: src/i18n/remote.tsx
msgid "Provider"
msgstr "Provider"

#: src/i18n/remote.tsx
msgid "Provider confirmed. Changes apply to the next message."
msgstr "Provider 已确认。更改将应用于下一条消息。"

#: src/i18n/remote.tsx
msgid "Query"
msgstr "查询"

#: src/i18n/remote.tsx
msgid "Questions"
msgstr "问题"

#: src/i18n/remote.tsx
msgid "Queue"
msgstr "加入队列"

#: src/i18n/remote.tsx
msgid "Queue for next turn"
msgstr "加入下一轮队列"

#: src/i18n/remote.tsx
msgid "Queueing…"
msgstr "正在加入队列…"

#: src/i18n/remote.tsx
msgid "Raw result"
msgstr "原始结果"

#: src/i18n/remote.tsx
msgid "read"
msgstr "读取"

#: src/i18n/remote.tsx
msgid "Read"
msgstr "读取"

#: src/i18n/remote.tsx
msgid "Ready"
msgstr "就绪"

#: src/i18n/remote.tsx
msgid "Reasoning trace"
msgstr "推理过程"

#: src/i18n/remote.tsx
msgid "Referenced resources"
msgstr "引用的资源"

#: src/i18n/remote.tsx
msgid "Rejected"
msgstr "已驳回"

#: src/i18n/remote.tsx
msgid "REMOTE SESSION"
msgstr "远程会话"

#: src/i18n/remote.tsx
msgid "Remove skill {name}"
msgstr "移除技能 {name}"

#: src/i18n/remote.tsx
msgid "Renamed"
msgstr "重命名"

#: src/i18n/remote.tsx
msgid "Request changes"
msgstr "要求修改"

#: src/i18n/remote.tsx
msgid "Request revision"
msgstr "要求修订"

#: src/i18n/remote.tsx
msgid "Required"
msgstr "必填"

#: src/i18n/remote.tsx
msgid "Resource request failed."
msgstr "资源请求失败。"

#: src/i18n/remote.tsx
msgid "Resources"
msgstr "资源"

#: src/i18n/remote.tsx
msgid "Result"
msgstr "结果"

#: src/i18n/remote.tsx
msgid "Result truncated to fit the timeline."
msgstr "结果已截断以适应时间线。"

#: src/i18n/remote.tsx
msgid "Retry"
msgstr "重试"

#: src/i18n/remote.tsx
msgid "Retry documentation"
msgstr "重试加载文档"

#: src/i18n/remote.tsx
msgid "Return here after completing the action."
msgstr "完成操作后请返回此处。"

#: src/i18n/remote.tsx
msgid "Review proposed plan"
msgstr "审核拟定计划"

#: src/i18n/remote.tsx
msgid "Review requested access"
msgstr "审阅请求的访问权限"

#: src/i18n/remote.tsx
msgid "Revision feedback"
msgstr "修改反馈"

#: src/i18n/remote.tsx
msgid "Running"
msgstr "运行中"

#: src/i18n/remote.tsx
msgid "Runtime"
msgstr "运行时"

#: src/i18n/remote.tsx
msgid "Runtime notice"
msgstr "运行时提示"

#: src/i18n/remote.tsx
msgid "Saved history"
msgstr "已保存的历史"

#: src/i18n/remote.tsx
msgid "Selected skill"
msgstr "已选技能"

#: src/i18n/remote.tsx
msgid "Send input to the active native turn"
msgstr "向当前原生轮次发送输入"

#: src/i18n/remote.tsx
msgid "Send message"
msgstr "发送消息"

#: src/i18n/remote.tsx
msgid "Sending…"
msgstr "发送中…"

#: src/i18n/remote.tsx
msgid "Session"
msgstr "会话"

#: src/i18n/remote.tsx
msgid "Session controls"
msgstr "会话控件"

#: src/i18n/remote.tsx
msgid "Session planning mode"
msgstr "会话规划模式"

#: src/i18n/remote.tsx
msgid "Session setting could not be changed."
msgstr "无法更改会话设置。"

#: src/i18n/remote.tsx
msgid "Session status"
msgstr "会话状态"

#: src/i18n/remote.tsx
msgid "Session status and planning"
msgstr "会话状态与规划"

#: src/i18n/remote.tsx
msgid "Session subagents"
msgstr "会话子 Agent"

#: src/i18n/remote.tsx
msgid "Settings can change only while idle with no pending interactions."
msgstr "仅在空闲且无待处理交互时可更改设置。"

#: src/i18n/remote.tsx
msgid "Show details"
msgstr "显示详情"

#: src/i18n/remote.tsx
msgid "Show full result"
msgstr "显示完整结果"

#: src/i18n/remote.tsx
msgid "Show questions"
msgstr "显示问题"

#: src/i18n/remote.tsx
msgid "Skill"
msgstr "技能"

#: src/i18n/remote.tsx
msgid "Skill details"
msgstr "技能详情"

#: src/i18n/remote.tsx
msgid "Start a new native turn"
msgstr "开始新的原生轮次"

#: src/i18n/remote.tsx
msgid "Starting"
msgstr "正在启动"

#: src/i18n/remote.tsx
msgid "Status"
msgstr "状态"

#: src/i18n/remote.tsx
msgid "Steer"
msgstr "引导"

#: src/i18n/remote.tsx
msgid "Steer current turn"
msgstr "引导当前轮次"

#: src/i18n/remote.tsx
msgid "Steering…"
msgstr "正在引导…"

#: src/i18n/remote.tsx
msgid "Subagents"
msgstr "子 Agent"

#: src/i18n/remote.tsx
msgid "Submit"
msgstr "提交"

#: src/i18n/remote.tsx
msgid "Submit response"
msgstr "提交回答"

#: src/i18n/remote.tsx
msgid "Submitted"
msgstr "已提交"

#: src/i18n/remote.tsx
msgid "Submitting…"
msgstr "正在提交…"

#: src/i18n/remote.tsx
msgid "TASK BOARD"
msgstr "任务看板"

#: src/i18n/remote.tsx
msgid "The host cannot respond to this external action request."
msgstr "主机无法响应此外部操作请求。"

#: src/i18n/remote.tsx
msgid "The host cannot respond to this form request."
msgstr "主机无法响应此表单请求。"

#: src/i18n/remote.tsx
msgid "The host cannot respond to this permission approval request."
msgstr "主机无法响应此权限审批请求。"

#: src/i18n/remote.tsx
msgid "The host cannot respond to this plan approval request."
msgstr "当前宿主无法响应此计划审批请求。"

#: src/i18n/remote.tsx
msgid "The host cannot respond to this question request."
msgstr "当前宿主无法回答此提问请求。"

#: src/i18n/remote.tsx
msgid "The host cannot respond to this tool approval request."
msgstr "当前宿主无法响应此工具审批请求。"

#: src/i18n/remote.tsx
msgid "The recorded interaction response does not match its request."
msgstr "已记录的交互回答与请求不匹配。"

#: src/i18n/remote.tsx
msgid "The requested link cannot be opened."
msgstr "无法打开请求的链接。"

#: src/i18n/remote.tsx
msgid "This answer is hidden in conversation history."
msgstr "此回答在对话历史中隐藏。"

#: src/i18n/remote.tsx
msgid "This Provider can invoke skills when the current turn finishes."
msgstr "此 Provider 可以在当前轮次结束后调用技能。"

#: src/i18n/remote.tsx
msgid "This Provider does not expose native commands."
msgstr "此 Provider 不提供原生命令。"

#: src/i18n/remote.tsx
msgid "This Provider does not expose these session settings."
msgstr "此 Provider 不提供这些会话设置。"

#: src/i18n/remote.tsx
msgid "This Provider exposes a description without full documentation."
msgstr "此 Provider 仅提供说明，没有完整文档。"

#: src/i18n/remote.tsx
msgid "This subagent could not be opened."
msgstr "无法打开此子 Agent。"

#: src/i18n/remote.tsx
msgid "TOOL APPROVAL"
msgstr "工具审批"

#: src/i18n/remote.tsx
msgid "TOOL AUTHORIZATION"
msgstr "工具授权"

#: src/i18n/remote.tsx
msgid "Tool result"
msgstr "工具结果"

#: src/i18n/remote.tsx
msgid "Trigger: automatic"
msgstr "触发原因：自动"

#: src/i18n/remote.tsx
msgid "Trigger: manual"
msgstr "触发原因：手动"

#: src/i18n/remote.tsx
msgid "Turn elapsed time"
msgstr "当前轮次耗时"

#: src/i18n/remote.tsx
msgid "Unable to load native commands."
msgstr "无法加载原生命令。"

#: src/i18n/remote.tsx
msgid "Unable to load skill documentation."
msgstr "无法加载技能文档。"

#: src/i18n/remote.tsx
msgid "Unavailable"
msgstr "不可用"

#: src/i18n/remote.tsx
msgid "Unknown interaction"
msgstr "未知交互"

#: src/i18n/remote.tsx
msgid "Unknown or unavailable native command. Open / to refresh the command list."
msgstr "原生命令未知或不可用。输入 / 刷新命令列表。"

#: src/i18n/remote.tsx
msgid "Unsupported interaction"
msgstr "不支持此交互"

#: src/i18n/remote.tsx
msgid "URL"
msgstr "网址"

#: src/i18n/remote.tsx
msgid "User message"
msgstr "用户消息"

#: src/i18n/remote.tsx
msgid "View skill {name}"
msgstr "查看技能 {name}"

#: src/i18n/remote.tsx
msgid "Waiting for Provider confirmation."
msgstr "等待 Provider 确认。"

#: src/i18n/remote.tsx
msgid "Waiting for Provider planning state."
msgstr "等待 Provider 的规划状态。"

#: src/i18n/remote.tsx
msgid "Waiting for response"
msgstr "等待响应"

#: src/i18n/remote.tsx
msgid "What should the Agent change?"
msgstr "需要 Agent 修改哪些内容？"

#: src/i18n/remote.tsx
msgid "Working"
msgstr "工作中"

#: src/i18n/remote.tsx
msgid "write"
msgstr "写入"

#: src/i18n/remote.tsx
msgid "Write"
msgstr "写入"

#: src/i18n/remote.tsx
msgid "Yes"
msgstr "是"

#: src/i18n/remote.tsx
msgid "You"
msgstr "你"
